"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.ProductScoopEventActions = exports.EventTypes = exports.ProductScoopPromoTypes = void 0;
var ProductScoopPromoTypes;
(function (ProductScoopPromoTypes) {
    ProductScoopPromoTypes["scoopAll"] = "SCOOPALL";
    ProductScoopPromoTypes["scoopCur"] = "SCOOPCUR";
})(ProductScoopPromoTypes = exports.ProductScoopPromoTypes || (exports.ProductScoopPromoTypes = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["ProductScoopEvent"] = "ProductScoopEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ProductScoopEventActions;
(function (ProductScoopEventActions) {
    ProductScoopEventActions["ProductScoopCreated"] = "ProductScoopCreated";
    ProductScoopEventActions["ProductScoopUpdated"] = "ProductScoopUpdated";
    ProductScoopEventActions["ProductScoopDeleted"] = "ProductScoopDeleted";
    ProductScoopEventActions["CreateProductScoop"] = "CreateProductScoop";
    ProductScoopEventActions["UpdateProductScoop"] = "UpdateProductScoop";
    ProductScoopEventActions["DeleteProductScoop"] = "DeleteProductScoop";
})(ProductScoopEventActions = exports.ProductScoopEventActions || (exports.ProductScoopEventActions = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyProductScoop"] = "MyProductScoop";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
